<template>
	<div :inert="disabled">
		<label :for="inputId" class="flex cursor-pointer select-none items-center">
			<span v-if="props.labelLocation === 'left'" class="text-label" :class="[labelOpacity, labelTextSizeClass, { 'mr-2': label }]">{{ props.label }}</span>
			<div class="relative">
				<input ref="input" type="checkbox" :id="inputId" class="sr-only" v-model="isChecked" @change="emit('checkedChanged', isChecked)" :tabindex="tabindex" />
				<div :class="[bgColor, bgOpacity, borderColor, borderOpacity, boxSizeClass]"
					  class="flex items-center justify-center rounded border-2">
          <span :class="checkmarkOpacity">
            <svg xmlns="http://www.w3.org/2000/svg" :class="checkSizeClass" viewBox="0 0 24 24" fill="none" >
              <path d="M16.5 8.25L10.2 15.75L7.5 12.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
				</div>
			</div>
			<span v-if="props.labelLocation === 'right'"  class="text-label" :class="[labelOpacity, labelTextSizeClass, { 'ml-2': label }]">{{ props.label }}</span>
		</label>
	</div>
</template>

<script setup lang="js">
import { computed, defineModel, onMounted, ref, useId } from 'vue'

const input = ref('')
const id = ref('')
const props = defineProps({
	label: { type: String },
	disabled: { type: Boolean, default: false },
	hasError: { type: Boolean, default: false },
	labelLocation: { type: String, default: 'right' },//right, left
	labelTextSizeClass: { type: String, default: 'text-sm' },
	inputId: { type: String, default: null },
	boxSizeClass: { type: String, default: 'size-5' },
	checkSizeClass: { type: String, default: 'size-6' },
	tabindex: { type: Number, default: null },
})

onMounted(() =>
{
	//This doesn't work if you're loading multiple checkboxes at the same time
	id.value = (!props.inputId) ? useId() : props.inputId
})

const isChecked = defineModel({ type: Boolean, default: false })
const emit = defineEmits(['checkedChanged'])

const bgColor = computed(() => {
	if (isChecked.value) {
		if (props.hasError) {
			return 'bg-error'
		} else {
			return 'bg-primary'
		}
	}

	return 'bg-neutral'
})

const getInputId = () => {
	return id.value
}

const getIsChecked = () => {
	return isChecked.value
}

const performClick = () => {
	input.value.click()
}

const borderColor = computed(() => {
	if (props.hasError) {
		return 'border-error'
	}

	return 'border-primary'
})

const bgOpacity = computed(() => {
	if (props.disabled) {
		return 'bg-opacity-70'
	}

	return 'bg-opacity-100'
})

const borderOpacity = computed(() => {
	if (props.disabled) {
		if (isChecked.value) {
			return 'border-opacity-0'
		} else {
			return 'border-opacity-70'
		}
	}

	return 'border-opacity-100'
})

const checkmarkOpacity = computed(() => {
	if (isChecked.value) {
		return 'opacity-100'
	}

	return 'opacity-0'
})

const labelOpacity = computed(() => {
	if (props.disabled) {
		return 'text-opacity-70'
	}

	return 'text-opacity-100'
})

defineExpose({
	getInputId,
	getIsChecked,
	performClick,
})

</script>
